import { MenuItem, Select, TextField } from "@mui/material";
import "./dashboardFileds.css";
import { useEffect, useState } from "react";
import goBtn from "../../assets/icons/arrow-right.svg";
import isValidUSZipCode from "../../utils/isZipCodeValid";
import { useDispatch } from "react-redux";
import { filterMobileDevice } from "../../redux/reducers/resellerAgentDashboard";

export default function DashboardFileds({
  field,
  type,
  dropdown,
  setField,
  fieldValue,
  validationError,
  dropdownRef,
  planEmpty,
  disabled,
  index,
  autoComplete,
  requiredMark,
  dropdownDatas,
  limit,
  getState,
  id,
}) {
  const [open, setOpen] = useState(false);
  const [toggleSearch, setToggleSearch] = useState(false);
  const [searchOptPlan, setSearchOptPlan] = useState("");
  const [dropdownData, setDropdownData] = useState([]);
  const [planId, setPlanId] = useState(id);
  const dispatch = useDispatch();

  // const isFinancingOpt = field.field === "financingOptions";
  const handleClose = (event) => {
    // if (event.target.type === "text" || isFinancingOpt) {
    if (event.target.type === "text") {
      return;
    }
    setOpen(false);
    setToggleSearch(true);
    setSearchOptPlan("");
    if (id) {
      dispatch(
        filterMobileDevice({
          details: {
            plan_id: id,
          },
        })
      );
    }
  };
  useEffect(() => {
    if (id === undefined) {
      return;
    }
    if (planId === undefined || planId !== id) {
      setPlanId(id);
    }
  }, [id, planId]);

  const handleChange = (event, index) => {
    const {
      target: { value },
    } = event;
    setField(field?.field, value, index);
    setDropdownData(dropdownDatas);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        field.field === "optimum_plans" &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        event.target.type !== "text" &&
        !event.target.closest(".MuiMenuItem-root")
      ) {
        setOpen(false);
        setToggleSearch(true);
        setSearchOptPlan("");
      }
    };
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, id]);

  useEffect(() => {
    if (searchOptPlan.length === 0 && !toggleSearch && id) {
      // dispatch(
      //   filterMobileDevice({
      //     details: {
      //       plan_id: id,
      //       search_text: searchOptPlan,
      //     },
      //   })
      // );
    }
    if (field?.field === "optimum_plans") {
      const searchResult =
        dropdownDatas?.filter((item) =>
          item.name.toLowerCase().includes(searchOptPlan.toLowerCase())
        ) ?? [];

      setDropdownData(searchResult);
    }
    if (searchOptPlan && !!id) {
      // Debounced API call for mobile_devices
      dispatch(
        filterMobileDevice({
          details: {
            plan_id: id,
            search_text: searchOptPlan,
          },
        })
      );
    }
  }, [searchOptPlan, planId, id]);

  useEffect(() => {
    if (dropdownDatas && Array.isArray(dropdownDatas)) {
      setDropdownData(dropdownDatas);
    } else {
      setDropdownData([]);
    }
  }, [dropdownDatas]);
  return (
    <>
      <p className="field-name">
        {field?.name} {requiredMark && <span>*</span>}
      </p>
      {dropdown ? (
        <Select
          name={field.field}
          className="select"
          displayEmpty
          // multiple={isFinancingOpt ? true : false}
          open={open}
          onOpen={() => {
            setOpen(true);
            setToggleSearch(false);
          }}
          onClick={(e) => handleClose(e)}
          value={
            // planEmpty
            //   ? fieldValue[field?.field] || (isFinancingOpt ? [] : "")
            //   : fieldValue[field?.field]
            fieldValue?.[field?.field]?.name || fieldValue?.[field?.field] || ""
          }
          disabled={disabled}
          onChange={(e) => handleChange(e, index)}
          IconComponent={() => null}
          renderValue={(selected) => {
            if (!selected || !selected.length) {
              return <p>Select</p>;
            }
            // return isFinancingOpt ? selected.join(", ") : selected;
            return <p className="selected-value">{selected}</p>;
          }}
        >
          {(field?.field === "optimum_plans" ||
            field?.field === "mobile_devices") && (
            <TextField
              className="input"
              autoComplete="off"
              type="text"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "none",
                  },
                },
                "& input": {
                  border: "1px solid var(--grey)",
                  borderRadius: "10px",
                  height: "36px",
                  padding: "0px 14px",
                  width: "161px",
                },
                "& .MuiInputBase-root": {
                  padding: "15px",
                },
              }}
              placeholder="Search..."
              fullWidth
              value={searchOptPlan}
              onChange={(e) => setSearchOptPlan(e.target.value)}
              onKeyDown={(e) => e.stopPropagation()}
            />
          )}
          {/* <div className="menu-items"> */}
          <MenuItem value="" className="dashboard-menu-item">
            <span>Select</span>
          </MenuItem>
          {dropdownData.length > 0 &&
            dropdownData?.map((item, i) => {
              return (
                <MenuItem
                  key={item?.sim_name + i || item.id}
                  // value={item?.sim_name || item}
                  value={item?.sim_name || { ...item, index: i }}
                  className="dashboard-menu-item"
                >
                  <span>{item?.sim_name || item.name}</span>
                </MenuItem>
              );
            })}
          {/* <p className="error">{validationError[field?.field]}</p> */}
        </Select>
      ) : type === "textarea" ? (
        <textarea
          maxLength={limit}
          className="input"
          autoComplete={autoComplete || "off"}
          placeholder="Enter here"
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                border: "none",
              },
            },
          }}
          value={fieldValue[field.field] || ""}
          onChange={(e) => setField(field.field, e.target.value)}
        />
      ) : (
        <>
          <TextField
            id={
              fieldValue[field.field]?.id
                ? String(fieldValue[field.field]?.id)
                : ""
            }
            className="input"
            autoComplete={autoComplete || "off"}
            type={type}
            error={false}
            disabled={disabled}
            placeholder={disabled ? "-" : "Enter here"}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                },
              },
            }}
            value={
              // (field.field === "location" && fieldValue.name) ||
              fieldValue[field.field]?.name || fieldValue[field.field] || ""
            }
            onChange={(e) =>
              e.target.value.length <= limit &&
              setField(field.field, e.target.value)
            }
          />
          {field.field === "zipcode" && (
            <button
              type="button"
              disabled={!isValidUSZipCode(fieldValue[field.field])}
              className={`btn go-btn ${
                !isValidUSZipCode(fieldValue[field.field]) && "disable "
              }`}
              onClick={() => getState(fieldValue[field.field])}
            >
              <img src={goBtn} alt="go btn" />
            </button>
          )}
        </>
      )}
      <p className="error">{validationError[field?.field]}</p>
    </>
  );
}
